<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <span style="display: inline-block;color: #48576a;font-size: 0.0875rem;line-height: 30px;margin-right: 5px;">付款日</span>
        <el-date-picker v-model="timevalue" size="small" type="daterange" style="width: 280px;"
                        :picker-options="pickerOptions2" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期"
                        align="right" value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>
      <div style="display: flex;justify-content: space-between">
        <input-search placeholder="住户名称/房间号" @search="searchKey" />
        <button-export
          :href="exportUrl"
          download="download.xls"
          style="margin: 0 0 0 8px"
          v-if="permissionCodes.indexOf('002006001') !== -1"
          :beforeDownload="beforeDownload"
          value="导出"/>
      </div>
    </div>
    <div class="search-line">
      <div class="btn-box">
        <input-select :selectTitle="'缴费渠道'" style="margin-right: 10px;" selectWidth="100px" :selectData="payChannelList" @search="search" :selectKey="'payChannel'" />
        <input-select :selectTitle="'缴费状态'" style="margin-right: 10px;" selectWidth="100px" :selectData="payStatusList" @search="search" :selectKey="'payStatus'" />
        <input-select :selectTitle="'发票状态'" style="margin-right: 10px;" selectWidth="100px" :selectData="invoiceStatusList" @search="search" :selectKey="'invoiceStatus'" />
        <input-select :selectTitle="'账单状态'" style="margin-right: 10px;" selectWidth="100px" :selectData="invalidStatusList" @search="search" :selectKey="'invalidStatus'" />
        <el-input placeholder="请输入内容" v-model="payDeadCount" size="small" style="width: 250px;" class="payDeadInput" type="number" @keyup.native.13="changePayDeadCount">
          <el-select v-model="payDeadStatus" slot="prepend" placeholder="请选择" class="prependSelect">
            <el-option label="逾期" value="1"></el-option>
            <el-option label="到期" value="2"></el-option>
          </el-select>
          <template slot="append">{{payDeadAppendText}}</template>
        </el-input>
      </div>
      <div class="btn-box">
        <!--<button-cancel value="批量开票" @cancel="updatePatchPayItemDetail" style="margin-left: 10px;" v-if="permissionCodes.indexOf('002003009') !== -1" />-->
      </div>
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @goToModifyPage="goToModifyPage" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" :tableOperationWidth="'120px'" @changePagination="changePagination" :hasOperation="false" :operationArr="operationArr" />
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/Button/ButtonAdd'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonExport from '../../../components/common/buttons/button-export'
  import ButtonUpload from '../../../components/common/buttons/button-upload'
  import InputSearch from '../../../components/Input/InputSearch'
  import InputSelect from '../../../components/Input/InputSelect'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/InvestmentLeasing'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nError, nSuccess} from '../../../utils/notice'
  import {bus} from '../../../utils/bus'
  import ButtonCancel from '../../../components/Button/ButtonCancel'

  export default {
    components: {
      ButtonCancel,
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      ButtonAdd,
      Breadcrumb},
    name: 'rent-management',
    data () {
      return {
        breadcrumb: [{
          value: '其他合约',
          name: 'other-custom-management'
        }, {
          value: '账单管理'
        }],
        permissionCodes: '',
        timevalue: [],
        pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        tableHead: [{
          prop: 'leaseName',
          label: '主体名称'
        }, {
          prop: 'payMoneyText',
          label: '应缴金额(元)',
          width: '100'
        }, {
          prop: 'duration',
          label: '区间'
        }, {
          prop: 'payDeadline',
          label: '付款日',
          width: '120'
        }, {
          prop: 'payDeadCountText',
          label: '到期时间',
          showColor: true,
          width: '120'
        }, {
          prop: 'payTime',
          label: '缴费时间',
        }, {
          prop: 'payChannelText',
          label: '缴费渠道',
          width: '100'
        }, {
          prop: 'payStatusText',
          label: '缴费状态',
          width: '100'
        }, {
          prop: 'invoiceStatusText',
          label: '发票状态',
          width: '100'
        }, {
          prop: 'invalidStatusText',
          label: '账单状态',
          width: '100'
        }],
        exportUrl: '',
        tableData: [],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        selectionArr: [],
        payChannelList: [{
          key: '',
          label: '全部'
        }, {
          key: '1',
          label: '微信'
        }, {
          key: '2',
          label: '支付宝'
        }, {
          key: '3',
          label: '银行转账'
        }, {
          key: '4',
          label: '现金'
        }, {
          key: '5',
          label: '其他'
        }],
        payStatusList: [{
          key: '',
          label: '全部'
        }, {
          key: '0',
          label: '未缴费'
        }, {
          key: '1',
          label: '已缴费'
        }, {
          key: '2',
          label: '部分缴费'
        }, {
          key: '3',
          label: '已缴费--变更'
        }, {
          key: '4',
          label: '未缴费--变更'
        }, {
          key: '5',
          label: '已退款'
        }, {
          key: '6',
          label: '审批中'
        }],
        invoiceStatusList: [{
          key: '',
          label: '全部'
        }, {
          key: '0',
          label: '未开票'
        }, {
          key: '1',
          label: '已开票'
        }, {
          key: '2',
          label: '开票中'
        }],
        invalidStatusList: [{
          key: '',
          label: '全部'
        }, {
          key: '0',
          label: '正常'
        }, {
          key: '1',
          label: '已作废'
        }, {
          key: '2',
          label: '已退租'
        }],
        payDeadCount: '',
        payDeadStatus: '1',
        payDeadAppendText: '天外',
        requestData: {
          searchKey: '',
          payChannel: '',
          payStatus: '',
          invoiceStatus: '',
          invalidStatus: '',
          feeType: '租金',
          overDayCount: '',
          payDeadCount: '',
          startTime: '',
          endTime: ''
        },
        wantModifyData: {},
        operationArr: ['modify']
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getPage()
    },
    activated() {
      this.getPage()
    },
    methods: {
      beforeDownload () {
        this.exportUrl = `${api.exportForOtherPayDetail}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&invoiceStatus=${this.requestData.invoiceStatus}&invalidStatus=${this.requestData.invalidStatus}&searchKey=${this.requestData.searchKey}&feeType=${this.requestData.feeType}&overDayCount=${this.requestData.overDayCount}&payDeadCount=${this.requestData.payDeadCount}&payChannel=${this.requestData.payChannel}&payStatus=${this.requestData.payStatus}`
      },
      getCreatTime () {
        let nowDate = new Date
        let year = nowDate.getFullYear()
        let month = (nowDate.getMonth() + 1) < 10 ? '0' + (nowDate.getMonth() + 1) : (nowDate.getMonth() + 1)
        let date = nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate()
        this.timevalue[0] = year + '-' + month + '-01'
        this.timevalue[1] = year + '-' + month + '-' + date
        this.getPage()
      },
      getPage () {
        if (this.timevalue) {
          this.requestData.startTime = this.timevalue[0] || ''
          this.requestData.endTime = this.timevalue[1] || ''
        } else {
          this.requestData.startTime = ''
          this.requestData.endTime = ''
        }
        let reqData = this.requestData
        reqData.pageNum = this.pageNum
        reqData.pageSize = this.pageSize
        this.$axios.post(api.getOtherPayItemDetailPage, reqData)
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data.list
              data.map(v => {
                v.children = v.childItems
                if (v.childItems) {
                  v.childItems.map(child => {
                    child.payMoneyText = child.payMoney + ''
                    child.childItems = []

                    if (child.payChannel === '1') {
                      child.payChannelText = '微信'
                    } else if (child.payChannel === '2') {
                      child.payChannelText = '支付宝'
                    } else if (child.payChannel === '3') {
                      child.payChannelText = '银行转账'
                    } else if (child.payChannel === '4') {
                      child.payChannelText = '现金'
                    } else if (child.payChannel === '5') {
                      child.payChannelText = '其他'
                    } else {
                      child.payChannelText = '--'
                    }
                    if (child.invoiceStatus === '0') {
                      child.invoiceStatusText = '未开票'
                    } else if (child.invoiceStatus === '1') {
                      child.invoiceStatusText = '已开票'
                    } else if (child.invoiceStatus === '2') {
                      child.invoiceStatusText = '开票中'
                    }
                    this.payStatusList.map(statusItem => {
                      if (child.payStatus === statusItem.key) {
                        child.payStatusText = statusItem.label
                      }
                    })
                    if (child.hsbz === '1') {
                      child.hsbzState = false
                    } else {
                      child.hsbzState = true
                    }
                    if (child.overDayCount) {
                      child.payDeadCountText = `已逾期${child.overDayCount}天`
                      child.fontColorToPeople = '#B22222'
                    } else if (child.payDeadCount) {
                      child.payDeadCountText = `${child.payDeadCount}天后到期`
                      child.fontColorToPeople = '#FF9933'
                    } else {
                      child.payDeadCountText = '--'
                    }
                  })
                }

                v.payMoneyText = v.payMoney + ''
                if (v.payChannel === '1') {
                  v.payChannelText = '微信'
                } else if (v.payChannel === '2') {
                  v.payChannelText = '支付宝'
                } else if (v.payChannel === '3') {
                  v.payChannelText = '银行转账'
                } else if (v.payChannel === '4') {
                  v.payChannelText = '现金'
                } else if (v.payChannel === '5') {
                  v.payChannelText = '其他'
                }
                if (v.invoiceStatus === '0') {
                  v.invoiceStatusText = '未开票'
                } else if (v.invoiceStatus === '1') {
                  v.invoiceStatusText = '已开票'
                } else if (v.invoiceStatus === '1') {
                  v.invoiceStatusText = '开票中'
                }
                if (v.invalidStatus === '0') {
                  v.invalidStatusText = '正常'
                } else if (v.invalidStatus === '1') {
                  v.invalidStatusText = '已作废'
                } else if (v.invalidStatus === '2') {
                  v.invalidStatusText = '已退租'
                }
                this.payStatusList.map(statusItem => {
                  if (v.payStatus === statusItem.key) {
                    v.payStatusText = statusItem.label
                  }
                })
                if (v.overDayCount) {
                  v.payDeadCountText = `已逾期${v.overDayCount}天`
                  v.fontColorToPeople = '#B22222'
                } else if (v.payDeadCount) {
                  v.payDeadCountText = `${v.payDeadCount}天后到期`
                  v.fontColorToPeople = '#FF9933'
                } else {
                  v.payDeadCountText = '--'
                }
              })
              this.total = res.data.data.total
              this.tableData = data
            }
          })
          .catch(errorHandler('获取租金信息失败'))
      },
      search (v) {
        this.pageNum = 1
        this.requestData[v.key] = v.value
        this.getPage()
      },
      searchKey (v) {
        this.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      changePayDeadCount () {
        if (this.payDeadCount) {
          this.payDeadCount=this.payDeadCount.replace(/\D/g,'')
        }
        if (this.payDeadStatus === '1') {
          this.requestData.overDayCount = this.payDeadCount
          this.requestData.payDeadCount = ''
        } else {
          this.requestData.payDeadCount = this.payDeadCount
          this.requestData.overDayCount = ''
        }
        this.getPage()
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      },
      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },
      goToModifyPage (code) {
        this.$router.push({
          path: `/rent_modify/${code}`
        })
      },

      // 批量开票
      updatePatchPayItemDetail () {
        let reqData = []
        let sumMoney = 0
        this.selectionArr.map(selection => {
          this.tableData.map(v => {
            if (selection === v.code && v.invoiceStatus === '0') {
              for (let i in v) {
                if (v[i] === '--') {
                  v[i] = ''
                }
              }
              reqData.push(v)
              reqData[reqData.length - 1].invoiceStatus = '1'
              sumMoney = sumMoney + parseFloat(v.payMoney)
            }
          })
        })
        if (reqData.length === 0) {
          nError('请选择未开票的记录')
          return false
        }
        this.$confirm(`本次开票总金额为：${sumMoney.toFixed(2)} 元，已开票的不计入在内，请核对信息`, '温馨提示', {
          type: 'info'
        })
          .then(() => {
            this.$axios.post(api.updatePatchPayItemDetail, reqData)
              .then(res => {
                nSuccess('修改成功')
                this.getPage()
              })
              .catch(() => {
                errorHandler('修改失败')
                this.getPage()
              })
          })
          .catch(() => {
            this.getPage()
          })
      }
    },
    watch: {
      payDeadStatus (val) {
        if (val === '1') {
          this.payDeadAppendText = '天外'
        } else if (val === '2') {
          this.payDeadAppendText = '天内'
        }
      },
      timevalue (val) {
        this.getPage()
      }
    }
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>

<style lang="less">
  .el-input--small .el-input__inner {
    line-height: 30px;
  }
  .el-dialog__header {
    text-align: left;
  }
  .payDeadInput {
    .el-input__inner {
      padding-right: 0;
    }
  }
  .prependSelect {
    width: 80px;
    .el-input__suffix {
      right: 12px;
    }
    .el-input__inner {
      padding: 0 30px 0 20px;
    }
  }
  .btn-box {
    .el-date-editor .el-range-separator {
      padding: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/InvestmentLeasing/OtherContracts/OtherRentManagement.vue